import React from "react";
import { Form, Input, Select, Button, Row, Col } from "antd";
import "./ContactUsConsumer.css";

const { TextArea } = Input;
const { Option } = Select;

const ContactUsConsumer: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Form submitted:", values);
    // Handle form submission here
  };

  return (
    <div className="contact-us-consumer">
      <div className="contact-content-wrapper">
        <h1 className="contact-title">Contact Us</h1>
        <h2 className="send-message-title">Send Message</h2>

        <div className="contact-main-content">
          <div className="contact-form-container">
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              className="contact-form"
            >
              <Form.Item
                label="Subject"
                name="subject"
                rules={[{ required: true, message: "Please select a subject" }]}
                className="form-item"
              >
                <div className="custom-select-wrapper">
                  <Select
                    placeholder="Select a report"
                    className="custom-select"
                    suffixIcon={
                      <div className="dropdown-arrow">
                        <svg
                          width="10"
                          height="5"
                          viewBox="0 0 10 5"
                          fill="none"
                        >
                          <path d="M5 5L0 0H10L5 5Z" fill="#4D4D4D" />
                        </svg>
                      </div>
                    }
                  >
                    <Option value="technical">Technical Issue</Option>
                    <Option value="payment">Payment Question</Option>
                    <Option value="application">Application Support</Option>
                    <Option value="general">General Inquiry</Option>
                    <Option value="other">Other</Option>
                  </Select>
                </div>
              </Form.Item>

              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter your name" }]}
                className="form-item"
              >
                <Input placeholder="Enter your name" className="custom-input" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
                className="form-item"
              >
                <Input
                  placeholder="Enter your email"
                  className="custom-input"
                />
              </Form.Item>

              <Form.Item
                label="Message"
                name="message"
                rules={[
                  { required: true, message: "Please enter your message" },
                ]}
                className="form-item message-item"
              >
                <TextArea
                  rows={8}
                  placeholder="Enter your message"
                  className="custom-textarea"
                />
              </Form.Item>

              <div className="submit-button-container">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="submit-button"
                >
                  Submit
                </Button>
              </div>
            </Form>
          </div>

          <div className="contact-image-container">
            <img
              src="/images/contactus.png"
              alt="Contact Us"
              className="contact-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsConsumer;
